import React from 'react';
import Grid from '../../Grid';
import { Typography } from '../../Typography';
var Layout = function (_a) {
    var title = _a.title, children = _a.children;
    return (React.createElement(Grid, { container: true, spacing: 5, style: { width: '99vw', padding: '15px' } },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography.H1, null, title)),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Grid, { container: true, direction: "column", alignContent: "center", spacing: 2 }, children))));
};
export default Layout;
//# sourceMappingURL=Layout.js.map